module.exports = __webpack_public_path__ + "img/icon_listmytools_add.a7de6080.svg";